/**
 * BPMN Viewer Application - Main Entry Point
 *
 * Process: Initialize and start BPMN viewer application
 *
 * UPSTREAM: User navigates to application URL
 * DOWNSTREAM: BPMN viewer initialized and first diagram loaded
 */

import './style.css'
import { initializeViewer, initializeNavigation } from '@bpmn-viewer'

/**
 * Application configuration
 */
const CONFIG = {
  /** Canvas container selector */
  canvasContainer: '#canvas',
  /** Default root process to load */
  defaultRootProcess: '../Processes/level-1-orchestration/media-workflow.bpmn'
} as const

/**
 * Activity: Initialize application
 *
 * Start Event: Application loaded
 * End Event: Viewer ready and first BPMN displayed
 */
async function initializeApp(): Promise<void> {
  try {
    // Service Task: Initialize BPMN viewer
    initializeViewer(CONFIG.canvasContainer)

    // Service Task: Initialize navigation with root process
    await initializeNavigation(CONFIG.defaultRootProcess)

    console.log('BPMN Viewer initialized successfully')
  } catch (error) {
    // Error Event: Initialization failed
    console.error('Failed to initialize BPMN viewer:', error)

    // User Task: Display error to user
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred'
    alert(`Failed to initialize BPMN viewer:\n\n${errorMessage}\n\nPlease check that BPMN files are available.`)
  }
}

// Start Event: DOM Content Loaded
document.addEventListener('DOMContentLoaded', () => {
  initializeApp()
})
